import React, { memo } from 'react'
import Button from 'transfix-ui/components/Button'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import { NewInterestSchemaType } from 'apps/fleet-planner/hooks/useLaneOfferInterestForm'
import { useCreateDedicatedLanesInquire } from 'apps/fleet-planner/types/apiTypes'
import { useModalState } from 'utils/hooks'
import { DedicatedLanesInquireModal } from '../../../DedicatedLanesInquireModal'

export interface IDedicatedLanesInquiryButtonProps {
  dedicatedLaneId: number
}

const DedicatedLanesInquiryButton = memo<IDedicatedLanesInquiryButtonProps>(
  ({ dedicatedLaneId }) => {
    const { openToast } = useGlobalToast()
    const { trackEvent } = useFMSAnalytics()

    const { createToggleHandler, modalState } = useModalState({
      inquiryModal: false,
    })
    const { inquiryModal: isInquiryModalOpen } = modalState || {}
    const openDedicatedLanesInquireModal = createToggleHandler('inquiryModal', true)
    const closeDedicatedLanesInquireModal = createToggleHandler('inquiryModal', false)

    const { loading: isLoadingInquire, mutate: createInquire } = useCreateDedicatedLanesInquire({})

    const submitContactUs = async (data: NewInterestSchemaType) => {
      try {
        const carrierInquiry = {
          shipper_rate_id: dedicatedLaneId,
          contact_phone: data?.contactPhone,
          contact_message: data?.contactMessage,
          contact_email: data?.contactEmail,
        }
        await createInquire({
          dedicated_lanes_bid_inquire: carrierInquiry,
        })
        openToast({
          toastType: 'default',
          toastMessage: 'Message sent.',
        })
        trackEvent(
          'Dedicated Lanes',
          'SUBMITTED_REQUEST_FOR_INFO_ON_DEDICATED_LANE',
          carrierInquiry
        )
        closeDedicatedLanesInquireModal()
      } catch (e) {
        openToast({
          toastType: 'alert',
          toastMessage: e.message || 'Something went wrong, please contact us.',
        })
      }
    }

    return (
      <div>
        <Button
          data-test='dedicated-lanes-bid-inquiry-button'
          fullWidth
          color='tertiary'
          size='large'
          onClick={openDedicatedLanesInquireModal}>
          I want more information
        </Button>

        {isInquiryModalOpen && (
          <DedicatedLanesInquireModal
            isOpen
            onClose={closeDedicatedLanesInquireModal}
            submitHandler={submitContactUs}
            cancelModalHandler={closeDedicatedLanesInquireModal}
            isLoading={isLoadingInquire}
          />
        )}
      </div>
    )
  }
)

export default DedicatedLanesInquiryButton
